// // Footer.js - UPDATED FOR ARIKONSULTS
// import React from "react";
// import { Link, Links } from "react-router-dom";
// import { motion } from "framer-motion";
// import {
//   FiFacebook,
//   FiTwitter,
//   FiInstagram,
//   FiLinkedin,
//   FiMail,
//   FiPhone,
//   FiMapPin,
//   FiHome,
//   FiInfo,

//   FiBriefcase,
//   FiUsers,
//   FiAward,
//   FiImage,
//   FiStar,
//   FiCpu,
//   FiBookOpen,
//   FiGlobe,
// } from "react-icons/fi";

// function Footer() {
//   const currentYear = new Date().getFullYear();

//   const socialLinks = [
//     { icon: <FiFacebook className="w-5 h-5" />, href: "#", label: "Facebook" },
//     { icon: <FiTwitter className="w-5 h-5" />, href: "#", label: "Twitter" },
//     {
//       icon: <FiInstagram className="w-5 h-5" />,
//       href: "#",
//       label: "Instagram",
//     },
//     { icon: <FiLinkedin className="w-5 h-5" />, href: "#", label: "LinkedIn" },
//   ];

//   const quickLinks = [
//     { name: "Home", path: "/", icon: <FiHome className="w-4 h-4" /> },
//     {
//       name: "Services",
//       path: "/services",
//       icon: <FiBriefcase className="w-4 h-4" />,
//     },
//     { name: "Contact", path: "/contact", icon: <FiMail className="w-4 h-4" /> },
//   ];

//   const aboutLinks = [
//     {
//       name: "Company Overview",
//       path: "/about",
//       icon: <FiInfo className="w-4 h-4" />,
//     },
//     {
//       name: "Technology",
//       path: "/technology",
//       icon: <FiCpu className="w-4 h-4" />,
//     },
//     {
//       name: "Testimonials",
//       path: "/testimonials",
//       icon: <FiStar className="w-4 h-4" />,
//     },
//     {
//       name: "Gallery",
//       path: "/gallery",
//       icon: <FiImage className="w-4 h-4" />,
//     },
//   ];

//   const teamLinks = [
//     {
//       name: "Management Team",
//       path: "/team/management",
//       icon: <FiUsers className="w-4 h-4" />,
//     },
//     {
//       name: "Consultancy Team",
//       path: "/team/consultancy",
//       icon: <FiUsers className="w-4 h-4" />,
//     },
//     { name: "All Team", path: "/team", icon: <FiUsers className="w-4 h-4" /> },
//   ];

//   const updatesLinks = [
//     {
//       name: "Projects",
//       path: "/projects",
//       icon: <FiAward className="w-4 h-4" />,
//     },
//     { name: "News", path: "/news", icon: <FiGlobe className="w-4 h-4" /> },
//     { name: "Blog", path: "/blog", icon: <FiBookOpen className="w-4 h-4" /> },
//   ];

//   return (
//     <footer className="bg-green-900 border-t border-green-700">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
//           {/* Brand Section */}
//           <div className="lg:col-span-2">
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               className="flex items-center space-x-3 mb-6"
//             >
//               <div className="w-12 h-12 bg-gradient-to-r from-green-500 to-emerald-500 rounded-xl flex items-center justify-center">
//                 <span className="text-white font-bold text-xl">A</span>
//               </div>
//               <div>
//                 <span className="text-white font-bold text-2xl bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent">
//                   Afrikonsults
//                 </span>
//                 <p className="text-green-400 text-sm">
//                   Transforming African Agriculture
//                 </p>
//               </div>
//             </motion.div>
//             <motion.p
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ delay: 0.1 }}
//               className="text-gray-300 mb-6 leading-relaxed"
//             >
//               Leading agricultural technology consultants in Africa, providing
//               innovative solutions for modern farming challenges through
//               cutting-edge technology and expert consultancy services.
//             </motion.p>
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ delay: 0.2 }}
//               className="flex space-x-4"
//             >
//               {socialLinks.map((social, index) => (
//                 <motion.a
//                   key={social.label}
//                   href={social.href}
//                   whileHover={{ scale: 1.2, y: -2 }}
//                   className="w-10 h-10 bg-green-800 rounded-lg flex items-center justify-center text-gray-300 hover:text-green-400 hover:bg-green-700 transition-all duration-300"
//                 >
//                   {social.icon}
//                 </motion.a>
//               ))}
//             </motion.div>
//           </div>

//           {/* Quick Links */}
//           <div>
//             <motion.h3
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               className="text-white font-semibold text-lg mb-6"
//             >
//               Quick Links
//             </motion.h3>
//             <ul className="space-y-3">
//               {quickLinks.map((link, index) => (
//                 <motion.li
//                   key={link.name}
//                   initial={{ opacity: 0, y: 20 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   transition={{ delay: index * 0.1 }}
//                 >
//                   <Link
//                     to={link.path}
//                     className="text-gray-300 hover:text-green-400 transition-colors duration-300 flex items-center space-x-2 group"
//                   >
//                     {link.icon}
//                     <span className="group-hover:translate-x-1 transition-transform duration-300">
//                       {link.name}
//                     </span>
//                   </Link>
//                 </motion.li>
//               ))}
//             </ul>
//           </div>

//           {/* About & Team */}
//           <div>
//             <motion.h3
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               className="text-white font-semibold text-lg mb-6"
//             >
//               About & Team
//             </motion.h3>
//             <ul className="space-y-3">
//               {aboutLinks.map((link, index) => (
//                 <motion.li
//                   key={link.name}
//                   initial={{ opacity: 0, y: 20 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   transition={{ delay: index * 0.1 }}
//                 >
//                   <Link
//                     to={link.path}
//                     className="text-gray-300 hover:text-green-400 transition-colors duration-300 flex items-center space-x-2 group"
//                   >
//                     {link.icon}
//                     <span className="group-hover:translate-x-1 transition-transform duration-300">
//                       {link.name}
//                     </span>
//                   </Link>
//                 </motion.li>
//               ))}
//               {teamLinks.map((link, index) => (
//                 <motion.li
//                   key={link.name}
//                   initial={{ opacity: 0, y: 20 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   transition={{ delay: (index + aboutLinks.length) * 0.1 }}
//                 >
//                   <Link
//                     to={link.path}
//                     className="text-gray-300 hover:text-green-400 transition-colors duration-300 flex items-center space-x-2 group"
//                   >
//                     {link.icon}
//                     <span className="group-hover:translate-x-1 transition-transform duration-300">
//                       {link.name}
//                     </span>
//                   </Link>
//                 </motion.li>
//               ))}
//             </ul>
//           </div>

//           {/* Contact Info */}
//           <div>
//             <motion.h3
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               className="text-white font-semibold text-lg mb-6"
//             >
//               Contact Us
//             </motion.h3>
//             <div className="space-y-4">
//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ delay: 0.1 }}
//                 className="flex items-center space-x-3 text-gray-300 group"
//               >
//                 <div className="w-8 h-8 bg-green-800 rounded-lg flex items-center justify-center group-hover:bg-green-700 transition-colors">
//                   <FiMapPin className="w-4 h-4 text-green-400" />
//                 </div>
//                 <div>
//                   <span className="text-sm">Lagos, Nigeria</span>
//                   <p className="text-xs text-gray-400">Plot 192, AI Close; Federal Lowcost Housing Estate, Ikorodu, Lagos State</p>
//                 </div>
//               </motion.div>

//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ delay: 0.2 }}
//                 className="flex items-center space-x-3 text-gray-300 group"
//               >
//                 <div className="w-8 h-8 bg-green-800 rounded-lg flex items-center justify-center group-hover:bg-green-700 transition-colors">
//                   <FiPhone className="w-4 h-4 text-green-400" />
//                 </div>
//                 <div>
//                   <span className="text-sm">+234-8181184913</span> <br />
//                   <span className="text-sm">+234-8081081048</span> <br />
//                   <span className="text-sm">+234-8137259396</span>

//                   <p className="text-xs text-gray-400">Mon-Fri 8AM-6PM</p>
//                 </div>
//               </motion.div>

//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ delay: 0.3 }}
//                 className="flex items-center space-x-3 text-gray-300 group"
//               >
//                 <div className="w-8 h-8 bg-green-800 rounded-lg flex items-center justify-center group-hover:bg-green-700 transition-colors">
//                   <FiMail className="w-4 h-4 text-green-400" />
//                 </div>
//                 <div>
//                   <span className="text-sm">sooikeh@afrikonsults.com</span>
//                   <p className="text-xs text-gray-400">Quick Response</p>
//                 </div>
//               </motion.div>

//               {/* Updates Links */}
//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ delay: 0.4 }}
//                 className="pt-4 border-t border-green-700"
//               >
//                 <h4 className="text-green-400 font-semibold text-sm mb-3">
//                   Latest Updates
//                 </h4>
//                 <div className="space-y-2">
//                   {updatesLinks.map((link, index) => (
//                     <Link
//                       key={link.name}
//                       to={link.path}
//                       className="text-gray-300 hover:text-green-400 transition-colors duration-300 flex items-center space-x-2 text-xs group"
//                     >
//                       {link.icon}
//                       <span className="group-hover:translate-x-1 transition-transform duration-300">
//                         {link.name}
//                       </span>
//                     </Link>
//                   ))}
//                 </div>
//               </motion.div>
//             </div>
//           </div>
//         </div>

//         {/* Bottom Bar */}
//         <motion.div
//           initial={{ opacity: 0 }}
//           whileInView={{ opacity: 1 }}
//           className="border-t border-green-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center"
//         >
//           <div className="text-center md:text-left">
//             <p className="text-gray-400 text-sm">
//               © {currentYear} Arikonsults. All rights reserved. Developed by <Link to={'https://fusion-xe.vercel.app/'}>Collin Mwenda (FusionXe)</Link>
//             </p>
//             <p className="text-gray-500 text-xs mt-1">
//               Transforming African Agriculture Through Innovation
//             </p>
//           </div>
//           <div className="flex space-x-6 mt-4 md:mt-0">
//             <Link
//               to="/privacy"
//               className="text-gray-400 hover:text-green-400 text-sm transition-colors duration-300"
//             >
//               Privacy Policy
//             </Link>
//             <Link
//               to="/terms"
//               className="text-gray-400 hover:text-green-400 text-sm transition-colors duration-300"
//             >
//               Terms of Service
//             </Link>
//             <Link
//               to="/sitemap"
//               className="text-gray-400 hover:text-green-400 text-sm transition-colors duration-300"
//             >
//               Sitemap
//             </Link>
//           </div>
//         </motion.div>

//         {/* Call to Action */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           className="mt-8 p-6 bg-gradient-to-r from-green-800 to-emerald-800 rounded-xl border border-green-600 text-center"
//         >
//           <h3 className="text-white font-semibold text-lg mb-2">
//             Ready to Transform Your Agricultural Operations?
//           </h3>
//           <p className="text-gray-300 text-sm mb-4">
//             Get expert consultation and cutting-edge technology solutions for
//             your farm.
//           </p>
//           <Link
//             to="/contact"
//             className="inline-flex items-center space-x-2 px-6 py-3 bg-gradient-to-r from-green-500 to-emerald-500 rounded-2xl text-white font-semibold text-sm hover:from-green-600 hover:to-emerald-600 transition-all duration-300"
//           >
//             <span>Get Consultation</span>
//           </Link>
//         </motion.div>
//       </div>
//     </footer>
//   );
// }

// export default Footer;

// Footer.js - UPDATED WITH NIGERIA & KENYA OFFICES
import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  FiFacebook,
  FiTwitter,
  FiInstagram,
  FiLinkedin,
  FiMail,
  FiPhone,
  FiMapPin,
  FiHome,
  FiInfo,
  FiBriefcase,
  FiUsers,
  FiAward,
  FiImage,
  FiStar,
  FiCpu,
  FiBookOpen,
  FiGlobe,
  FiFlag,
} from "react-icons/fi";

function Footer() {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: <FiFacebook className="w-5 h-5" />, href: "#", label: "Facebook" },
    { icon: <FiTwitter className="w-5 h-5" />, href: "#", label: "Twitter" },
    {
      icon: <FiInstagram className="w-5 h-5" />,
      href: "#",
      label: "Instagram",
    },
    { icon: <FiLinkedin className="w-5 h-5" />, href: "#", label: "LinkedIn" },
  ];

  const quickLinks = [
    { name: "Home", path: "/", icon: <FiHome className="w-4 h-4" /> },
    {
      name: "Services",
      path: "/services",
      icon: <FiBriefcase className="w-4 h-4" />,
    },
    { name: "Contact", path: "/contact", icon: <FiMail className="w-4 h-4" /> },
  ];

  const aboutLinks = [
    {
      name: "Company Overview",
      path: "/about",
      icon: <FiInfo className="w-4 h-4" />,
    },
    {
      name: "Technology",
      path: "/technology",
      icon: <FiCpu className="w-4 h-4" />,
    },
    {
      name: "Testimonials",
      path: "/testimonials",
      icon: <FiStar className="w-4 h-4" />,
    },
    {
      name: "Gallery",
      path: "/gallery",
      icon: <FiImage className="w-4 h-4" />,
    },
  ];

  const teamLinks = [
    {
      name: "Management Team",
      path: "/team/management",
      icon: <FiUsers className="w-4 h-4" />,
    },
    {
      name: "Consultancy Team",
      path: "/team/consultancy",
      icon: <FiUsers className="w-4 h-4" />,
    },
    { name: "All Team", path: "/team", icon: <FiUsers className="w-4 h-4" /> },
  ];

  const updatesLinks = [
    {
      name: "Projects",
      path: "/projects",
      icon: <FiAward className="w-4 h-4" />,
    },
    { name: "News", path: "/news", icon: <FiGlobe className="w-4 h-4" /> },
    { name: "Blog", path: "/blog", icon: <FiBookOpen className="w-4 h-4" /> },
  ];

  return (
    <footer className="bg-green-900 border-t border-green-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              className="flex items-center space-x-3 mb-6"
            >
              <div className="w-12 h-12 bg-gradient-to-r from-green-500 to-emerald-500 rounded-xl flex items-center justify-center">
                <span className="text-white font-bold text-xl">A</span>
              </div>
              <div>
                <span className="text-white font-bold text-2xl bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent">
                  Afrikonsults
                </span>
                <p className="text-green-400 text-sm">
                  Transforming African Agriculture
                </p>
              </div>
            </motion.div>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              className="text-gray-300 mb-6 leading-relaxed"
            >
              Leading agricultural technology consultants in Africa, providing
              innovative solutions for modern farming challenges through
              cutting-edge technology and expert consultancy services.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="flex space-x-4"
            >
              {socialLinks.map((social, index) => (
                <motion.a
                  key={social.label}
                  href={social.href}
                  whileHover={{ scale: 1.2, y: -2 }}
                  className="w-10 h-10 bg-green-800 rounded-lg flex items-center justify-center text-gray-300 hover:text-green-400 hover:bg-green-700 transition-all duration-300"
                >
                  {social.icon}
                </motion.a>
              ))}
            </motion.div>
          </div>

          {/* Quick Links */}
          <div>
            <motion.h3
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              className="text-white font-semibold text-lg mb-6"
            >
              Quick Links
            </motion.h3>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <motion.li
                  key={link.name}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                >
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-green-400 transition-colors duration-300 flex items-center space-x-2 group"
                  >
                    {link.icon}
                    <span className="group-hover:translate-x-1 transition-transform duration-300">
                      {link.name}
                    </span>
                  </Link>
                </motion.li>
              ))}
            </ul>
          </div>

          {/* About & Team */}
          <div>
            <motion.h3
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              className="text-white font-semibold text-lg mb-6"
            >
              About & Team
            </motion.h3>
            <ul className="space-y-3">
              {aboutLinks.map((link, index) => (
                <motion.li
                  key={link.name}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                >
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-green-400 transition-colors duration-300 flex items-center space-x-2 group"
                  >
                    {link.icon}
                    <span className="group-hover:translate-x-1 transition-transform duration-300">
                      {link.name}
                    </span>
                  </Link>
                </motion.li>
              ))}
              {teamLinks.map((link, index) => (
                <motion.li
                  key={link.name}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: (index + aboutLinks.length) * 0.1 }}
                >
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-green-400 transition-colors duration-300 flex items-center space-x-2 group"
                  >
                    {link.icon}
                    <span className="group-hover:translate-x-1 transition-transform duration-300">
                      {link.name}
                    </span>
                  </Link>
                </motion.li>
              ))}
            </ul>
          </div>

          {/* Contact Info - Updated with Nigeria & Kenya Offices */}
          <div>
            <motion.h3
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              className="text-white font-semibold text-lg mb-6"
            >
              Our Offices
            </motion.h3>
            <div className="space-y-6">
              {/* Nigeria Office */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 }}
                className="group"
              >
                <div className="flex items-center space-x-2 mb-3">
                  <FiFlag className="w-4 h-4 text-green-400" />
                  <h4 className="text-green-400 font-semibold text-sm">
                    Nigeria Office
                  </h4>
                </div>

                <div className="space-y-3 pl-2">
                  <div className="flex items-start space-x-2 text-gray-300">
                    <FiMapPin className="w-4 h-4 text-green-400 mt-0.5 flex-shrink-0" />
                    <div>
                      <p className="text-sm">Lagos State, Nigeria</p>
                      <p className="text-xs text-gray-400">
                        Plot 192, AI Close; Federal Lowcost Housing Estate,
                        Ikorodu, Lagos State
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-2 text-gray-300">
                    <FiPhone className="w-4 h-4 text-green-400 mt-0.5 flex-shrink-0" />
                    <div>
                      <p className="text-sm">+234-7063330321</p>
                      <p className="text-sm">+234-7053330325</p>
                      <p className="text-sm">+234-8161184913</p>
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* Kenya Office */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
                className="group"
              >
                <div className="flex items-center space-x-2 mb-3">
                  <FiFlag className="w-4 h-4 text-green-400" />
                  <h4 className="text-green-400 font-semibold text-sm">
                    Kenya Office
                  </h4>
                </div>

                <div className="space-y-3 pl-2">
                  <div className="flex items-start space-x-2 text-gray-300">
                    <FiMapPin className="w-4 h-4 text-green-400 mt-0.5 flex-shrink-0" />
                    <div>
                      <p className="text-sm">Nairobi, Lavington Road</p>
                      <p className="text-xs text-gray-400">
                        Leo Residence, Apt B2-2, Hatheru
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start space-x-2 text-gray-300">
                    <FiPhone className="w-4 h-4 text-green-400 mt-0.5 flex-shrink-0" />
                    <div>
                      <p className="text-sm">+254-712205453</p>
                      <p className="text-sm">+234-8161184913</p>
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* Email Contact */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3 }}
                className="flex items-start space-x-2 text-gray-300 group pt-4 border-t border-green-700"
              >
                <FiMail className="w-4 h-4 text-green-400 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-sm">sooikeh@afrikonsults.com</p>
                  <p className="text-xs text-gray-400">
                    Email for both offices
                  </p>
                </div>
              </motion.div>

              {/* Office Hours */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
                className="pt-4 border-t border-green-700"
              >
                <h4 className="text-green-400 font-semibold text-sm mb-2">
                  Office Hours
                </h4>
                <div className="text-xs text-gray-300 space-y-1">
                  <p>Monday - Friday: 8:00 AM - 6:00 PM</p>
                  <p>Saturday: 9:00 AM - 2:00 PM</p>
                  <p className="text-gray-400 italic">
                    Both offices follow these hours
                  </p>
                </div>
              </motion.div>

              {/* Updates Links */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5 }}
                className="pt-4 border-t border-green-700"
              >
                <h4 className="text-green-400 font-semibold text-sm mb-3">
                  Latest Updates
                </h4>
                <div className="space-y-2">
                  {updatesLinks.map((link, index) => (
                    <Link
                      key={link.name}
                      to={link.path}
                      className="text-gray-300 hover:text-green-400 transition-colors duration-300 flex items-center space-x-2 text-xs group"
                    >
                      {link.icon}
                      <span className="group-hover:translate-x-1 transition-transform duration-300">
                        {link.name}
                      </span>
                    </Link>
                  ))}
                </div>
              </motion.div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          className="border-t border-green-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center"
        >
          <div className="text-center md:text-left">
            <p className="text-gray-400 text-sm">
              © {currentYear} Afrikonsults. All rights reserved. Developed by{" "}
              <Link
                to="https://fusion-xe.vercel.app/"
                className="text-green-400 hover:text-green-300 transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                Collin Mwenda (FusionXe)
              </Link>
            </p>
            <p className="text-gray-500 text-xs mt-1">
              Transforming African Agriculture Through Innovation
            </p>
          </div>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link
              to="/privacy"
              className="text-gray-400 hover:text-green-400 text-sm transition-colors duration-300"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-gray-400 hover:text-green-400 text-sm transition-colors duration-300"
            >
              Terms of Service
            </Link>
            <Link
              to="/sitemap"
              className="text-gray-400 hover:text-green-400 text-sm transition-colors duration-300"
            >
              Sitemap
            </Link>
          </div>
        </motion.div>

        {/* Call to Action */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="mt-8 p-6 bg-gradient-to-r from-green-800 to-emerald-800 rounded-xl border border-green-600 text-center"
        >
          <h3 className="text-white font-semibold text-lg mb-2">
            Ready to Transform Your Agricultural Operations?
          </h3>
          <p className="text-gray-300 text-sm mb-4">
            Get expert consultation and cutting-edge technology solutions for
            your farm from our Nigeria and Kenya offices.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center space-x-2 px-6 py-3 bg-gradient-to-r from-green-500 to-emerald-500 rounded-2xl text-white font-semibold text-sm hover:from-green-600 hover:to-emerald-600 transition-all duration-300"
          >
            <span>Get Consultation</span>
          </Link>
        </motion.div>
      </div>
    </footer>
  );
}

export default Footer;
